import React from 'react';
import { Monitor } from 'lucide-react';
import { Badge } from '@mui/material';
import { useActiveAlertsCount } from '../hooks/useActiveAlertsCount';

/**
 * Icône Monitoring avec badge pour afficher le nombre d'alertes actives
 */
export const MonitoringIcon: React.FC = () => {
  const activeAlertsCount = useActiveAlertsCount();

  return (
    <Badge
      badgeContent={activeAlertsCount}
      color="error"
      overlap="circular"
      sx={{
        '& .MuiBadge-badge': {
          fontSize: '0.6rem',
          height: '16px',
          minWidth: '16px',
          padding: '0 4px'
        }
      }}
    >
      <Monitor size={22} />
    </Badge>
  );
};
